import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=67af5fa5&scoped=true&lang=pug&"
import script from "./Pending.vue?vue&type=script&lang=js&"
export * from "./Pending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67af5fa5",
  null
  
)

export default component.exports